module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j1dTX"))).then(() => parcelRequire('iDabs'));